import { Box, Typography, Link } from '@mui/material';
import { getStyles } from './css/FooterStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ExternalLinks from '../../../shared/externalLinks';

const Footer = () => {
    const isDesktopOrLaptop = useMediaQuery('(min-width:1224px)');
    const styles = getStyles(isDesktopOrLaptop);

    return (
        <Box sx={styles.root}>
            <Box sx={styles.siteMapLinks}>
                <Box sx={styles.linkSection}>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.HOME} sx={styles.linkSectionHeader}>Hospitality</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.HOTELS} sx={styles.linkText}>Hotels & Resorts</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.VACATION_RENTALS} sx={styles.linkText}>Vacation Rentals</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.SEE_IT_IN_ACTION} sx={styles.linkText}>Example Guest Interactions</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.TESTIMONIALS} sx={styles.linkText}>Customer Testimonials</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.DIFFERENCES_FROM_RETAIL} sx={styles.linkText}>Differences from Retail</Link>
                    <Link href={ExternalLinks.MARKETING.HOSPITALITY.MORE_ADVANCED_FEATURES} sx={styles.linkText}>More Advanced Features</Link>
                    <Link href={ExternalLinks.MARKETING.PARTNERS} sx={styles.linkText}>Partners</Link>
                    <Link href={ExternalLinks.MARKETING.SUPPORT.HOME} sx={styles.linkText}>Support</Link>
                </Box>
                <Box sx={styles.linkSection}>
                    <Link href={ExternalLinks.MARKETING.SENIOR_LIVING.HOME} sx={styles.linkSectionHeader}>Senior Living</Link>
                    <Link href={ExternalLinks.MARKETING.SENIOR_LIVING.OVERVIEW} sx={styles.linkText}>Overview</Link>
                    <Link href={ExternalLinks.MARKETING.SENIOR_LIVING.SOLUTION_IMPACT} sx={styles.linkText}>Solution Impact</Link>
                    <Link href={ExternalLinks.MARKETING.SENIOR_LIVING.DIFFERENCES_FROM_RETAIL} sx={styles.linkText}>Differences from Retail</Link>
                </Box>
                <Box sx={styles.linkSection}>
                    <Link href={ExternalLinks.MARKETING.ABOUT.HOME} sx={styles.linkSectionHeader}>Company</Link>
                    <Link href={ExternalLinks.MARKETING.ABOUT.HOME} sx={styles.linkText}>About Us</Link>
                    <Link href={ExternalLinks.MARKETING.ABOUT.TEAM} sx={styles.linkText}>Our Team</Link>
                    <Link href={ExternalLinks.MARKETING.ABOUT.NEWS_ROOM} sx={styles.linkText}>News Room</Link>
                    <Link href={ExternalLinks.MARKETING.ABOUT.CONTACT} sx={styles.linkText}>Contact Us</Link>
                </Box>
                <Box sx={styles.linkSection}>
                    <Link href={ExternalLinks.MARKETING.ABOUT.NEWS_ROOM} sx={styles.linkSectionHeader}>Follow Us</Link>
                    <Link href={ExternalLinks.FACEBOOK} sx={styles.linkText}>Facebook</Link>
                    <Link href={ExternalLinks.TWITTER} sx={styles.linkText}>Twitter</Link>
                    <Link href={ExternalLinks.LINKEDIN} sx={styles.linkText}>LinkedIn</Link>
                </Box>
            </Box>
            <Box sx={styles.copyrightSection}>
                <Typography sx={styles.copyright}>© Copyright 2023 AIPEX Technologies, Inc</Typography>
                <Typography sx={styles.trademark}>AIPEX™ is a trademark of AIPEX Technologies, Inc</Typography>
                <Typography sx={styles.privacyPolicy}>
                    Patents Granted and Pending |&nbsp;
                    <Link href={ExternalLinks.MARKETING.PRIVACY} sx={styles.privacyPolicyLink}>Privacy Policy</Link>
                    &nbsp;|&nbsp;
                    <Link href={ExternalLinks.MARKETING.TERMS} sx={styles.privacyPolicyLink}>Terms of Use</Link>
                </Typography>
            </Box>
        </Box>
    );
}

export default Footer;